import { useState } from 'react'

import { Drawer, Badge } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import makeStyles from '@material-ui/core/styles/makeStyles'
import TuneIcon from '@mui/icons-material/Tune'
import FilterDrawerContent from './FilterDrawerContent'
import useFilterCollection from 'photo-module/filters-bar/core/filters.hooks'

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    top: 0,
    bottom: 0,
    height: 'auto',
    overflow: 'auto',
    width: '100%',
    '@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none))': {
      background: theme.palette.background.paper,
      backdropFilter: 'blur(5px)',
      borderRadius: '4px',
    },
  },
  badge: {
    position: 'relative',
    top: -14,
    right: -2,
    borderRadius: 14,
    '& > span': {
      fontSize: 11,
      fontWeight: 'bold',
      lineHeight: 'normal',
      color: theme.palette.background?.shadow || theme.palette.background.default,
      background: theme.palette.primary.main,
    },
  },
  iconButton: {
    margin: '20px 5px 0px 23px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '0px',
    padding: '3px 3px',
  },
  filterIcon: {
    width: '28px !important',
    height: '28px !important',
  },
}))

const FilterDrawer = ({ filterKeys, filterValues, FilterList }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const { selectedFilters } = useFilterCollection()

  const toggleOpen = () => setOpen(!open)
  const onClick = () => setOpen(wasOpen => !wasOpen)

  return (
    <>
      <IconButton onClick={onClick} className={classes.iconButton}>
        <TuneIcon className={classes.filterIcon} />
        { selectedFilters.length !== 0 && <Badge badgeContent={selectedFilters.length} className={classes.badge} /> }
      </IconButton>
      <Drawer
        open={open}
        onOpen={toggleOpen}
        onClose={toggleOpen}
        anchor="bottom"
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ invisible: true }}
      >
        <FilterDrawerContent filterKeys={filterKeys} filterValues={filterValues} close={toggleOpen} FilterList={FilterList} />
      </Drawer>
    </>
  )
}

export default FilterDrawer
